module.exports = __webpack_public_path__ + "img/email_client.a7addb68.svg";